export default function PopupWindow(props){
    return(
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center z-[9999]">
            <div className="bg-[#fafaff] rounded-lg shadow-lg p-6 w-[90%] md:w-[50%] lg:w-[30%] border border-[#000]">
                <div className="mb-4">{props.text}</div>
                <div className="w-full flex justify-center items-center gap-[8px] flex-wrap">
                    <button 
                        onClick={props.onClose} 
                        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                    >
                        關閉
                    </button>
                </div>
            </div>
        </div>
    )
}